/* 認証コード入力画面 */
import React, { useState, useEffect, useCallback } from 'react';
import Block from '../molecules/Block';
import Text from '../molecules/Text';
import Annotation from '../atoms/Annotation';
import CenterButton from '../atoms/CenterButton';
import axios from '../axios';
import { Row, Col } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import 'url-search-params-polyfill';
import LoadingModal from '../molecules/LoadingModal';
import { createRoot } from 'react-dom/client';

const AuthCode: React.FC = () => {
  // パスワード
  const [password, setPassword] = useState('');
  const [error_message, setErrorMessage] = useState('');

  //ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(false);
  useEffect(() => {
    handleBrowzerBack();
  }, []);

  /**
   * パスワード変更
   *
   * @param event イベント
   */
  const handleChagnePassword = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setPassword(value);
    },
    [setPassword]
  );

  /**
   * パスワード認証を行う
   */
  const handleNext = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post('/authcode', { password: password });
      if (response.data.result) {
        location.href = `${location.origin}${process.env.MIX_MOCK_URL}/mypage/agreement/guarantor`;
      }
    } catch (error) {
      setErrorMessage(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="mt-5"></div>
      <Block
        label="本人確認"
        content={
          <>
            <Annotation text="ご本人さまの確認として、仮パスワードを入力してください。" />
            <div className="mt-3"></div>
            <div>
              <Text
                id="password"
                label="仮パスワード"
                type="password"
                value={password}
                placeholder=""
                handleChange={handleChagnePassword}
                disabled={false}
                need={true}
                maxlength={200}
              />
            </div>
            {error_message && (
              // ログインエラー有
              <Row className="mt-5 d-flex align-items-center justify-content-center">
                <Col md={9} className="alert-danger alert-danger-custom">
                  {error_message}
                </Col>
              </Row>
            )}
          </>
        }
      />
      <div className="mt-5" />
      <CenterButton
        label="マイページ開設同意に進む"
        handleClick={handleNext}
        disabled={is_loading}
      />
      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
    </>
  );
};

const container = document.getElementById('authcode');
if (container) {
  const root = createRoot(container);
  root.render(<AuthCode />);
}
